import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, withModifiers as _withModifiers, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import Api from "@/services/api"
    import { Property, User } from "@/services/types"
    import { ElMessage, FormInstance, FormRules } from "element-plus"
    import { reactive, ref } from "vue"
    import { useRoute } from "vue-router"
    import { useStore } from "vuex"

    const required = true
    
export default /*@__PURE__*/_defineComponent({
  __name: 'CreateProp',
  setup(__props) {

    const store = useStore()
    const route = useRoute()
    const property = reactive<Property>({
        property: 'propriedade',
        value: 'Valor'
    })

    const rules = reactive<FormRules<Property>>({
        property: [{required, message: 'Insira o nome da propriedade'}],
        value: [{required, message: 'Insira um valor'}]
    })

    const saving = ref<boolean>(false)
    const formRef = ref<FormInstance>()

    const submit = async (formEl: FormInstance | undefined) => {
        if (!formEl) { return }
        await formEl.validate(async (valid) => {
            if (valid) {
                saving.value = true

                const res = await Api.post('admin/products/' + route.params.id, property)
                console.log(res.data)
                if (res.status == 200) {
                    ElMessage.success({message: 'Adicionada com sucesso'})
                    store.commit('setOpenModal', -1)
                    // location.reload()
                } else if (res.status == 422) {
                    if (res.data.errors) {
                        for(let err in res.data.errors) {
                            ElMessage.error({message: res.data.errors[err].join(', ')})
                        }
                    }
                } else {
                    ElMessage.error({message: 'Ocorreu um erro ' + res.data.message})
                }
                saving.value = false
            }
        })
    }

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createBlock(_component_el_form, {
    ref_key: "formRef",
    ref: formRef,
    disabled: saving.value,
    rules: rules,
    model: property,
    "label-position": "top"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_el_form_item, {
        label: "Propriedade",
        prop: "property"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_input, {
            type: "text",
            modelValue: property.property,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((property.property) = $event))
          }, null, 8, ["modelValue"])
        ]),
        _: 1
      }),
      _createVNode(_component_el_form_item, {
        label: "Valor",
        prop: "value"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_input, {
            type: "text",
            modelValue: property.value,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((property.value) = $event))
          }, null, 8, ["modelValue"])
        ]),
        _: 1
      }),
      _createVNode(_component_el_button, {
        plain: "",
        loading: saving.value,
        size: "large",
        type: "primary",
        onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (submit(formRef.value)), ["prevent"]))
      }, {
        default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
          _createTextVNode(" Salvar ", -1)
        ]))]),
        _: 1
      }, 8, ["loading"])
    ]),
    _: 1
  }, 8, ["disabled", "rules", "model"]))
}
}

})